import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { useLocation } from "react-router-dom";
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import FilterList from "components/__new/common/FilterList";

// import Print from "components/__new/common/Print";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { TableContent } from "components/__new/common/TableContent";
import DateFormat, { MonthIndex, MonthName, PadMonthIndex } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import logger from "utils/logger";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import processParams from "utils/processParams";
import useLoginInfo from "hooks/useLoginInfo";
import { DashboardBox2 } from "components/__new/common/DashboardBox";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import Filter, { ActiveFilter } from "components/__new/common/Filter";
import { ReactComponent as IconInvoice } from "assets/images/icons/invoice.svg";
import { ReactComponent as IconArrowDownLeft } from "assets/images/icons/arrow-down-left.svg";
import { ReactComponent as IconWalletDone } from "assets/images/icons/wallet-done.svg";
// import * as withdrawalsAction from "store/entities/withdrawals/action";
import * as payrollAction from "store/entities/payroll/payroll-version-1/action";
import PaymentNotesList from 'pages/payment-notes/list';
// import { width } from "tailwindcss/defaultTheme";


export const List = () => {
    const location = useLocation();
    const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const {urlQueryParams} = useUrlQueryParams();
    // const { InlineRouterTab } = useInlinePageRouter();
    const { InlineRouterTab, activeTab } = useInlinePageRouter("reconcilliation");
    const { loading: reportLoading, allPayroll: report, payrollMetricsLoading, payrollMetrics, downloadLoading: reportDownloadLoading, downloadAllPayroll: reportDownload } = useSelector((s) => s.entities.payroll);
    const isPaymentNotes = activeTab === "payment-notes";
    
    const downloadAsCSVRef = useRef();
    const printComponentRef = useRef();
    const [month, setMonth] = useState(""); // eslint-disable-line
    const [year, setYear] = useState(""); // eslint-disable-line
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    const [metricsParams, setMetricsParams] = useState({});
    const [invoices, setInvoices] = useState({})
    // const {amountDue, dueDate, totalWithdrawals} = invoices
    

    const setDefaultMonthYear = () => {
        const date = new Date();
        const currentMonthIndex = (date.getMonth() + 1);
        const month = MonthName(currentMonthIndex);
        const year = date.getFullYear();
        setMonth(month);
        setYear(year);
    }
    
    
    const transformFilters = (params) => {
        let paramsPayload = {...params};
        if (params.month && params.year){
            paramsPayload = {
                ...paramsPayload,
                month: PadMonthIndex(MonthIndex(params.month)),
                year: params.year,
            };
        }
        return paramsPayload;
    }
    
    
    const getPayrollMetrics = () => {
        dispatch(payrollAction.getPayrollMetrics(metricsParams));
    }
    
    const getReport = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "month", "string", "", "month");
        params = processParams(urlQueryParams, params, "year", "string", "", "year");
        params = processParams(urlQueryParams, params, "keyword", "string", listParams.value, "keyword");
        
        if (params?.month && params?.year){
            setMonth(params?.month);
            setYear(params?.year);
        }
        else{
            setDefaultMonthYear();
        }
        
        setListParams(params);
        const paramsPayload = transformFilters(params);
        dispatch(payrollAction.getAllPayroll(paramsPayload));
    }

    useEffect(() => {
        setDefaultMonthYear();
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        getPayrollMetrics();
        // eslint-disable-next-line
    }, [metricsParams?.dateFilter]);

    useEffect(() => {
        getReport();
        logger("employer-payroll-report", userInfo);
        // eslint-disable-next-line
    }, [location]);
    

    const handleFilterChange = (value = "") => {
        setMetricsParams({...metricsParams, dateFilter: value});
    }
    
    
    return (
        <div>

            <DynamicHeadTag
                headerText="Reconciliation"
                headerDescription="Track and reconcile all payment transactions made on your account."
            />

            <div>
            <div style={{ marginBottom: '14px'}} className="flex w-full justify-between items-center">
                    <h3 style={{ fontSize: '18px', lineHeight: '28px',}} className="font-medium text-ep-black pt-0">Reconciliation</h3>
                    <div className="">
                            <FilterList 
                                handleFilterChange={handleFilterChange}
                                options={[
                                    {
                                        name: "Today",
                                        value: "today",
                                    },
                                    {
                                        name: "Last 7 Days",
                                        value: "7days",
                                    },
                                    {
                                        name: "This Month",
                                        value: "thisMonth",
                                    },
                                    {
                                        name: "Last Month",
                                        value: "lastMonth",
                                    },
                                    {
                                        name: "Year to Date",
                                        value: "yearToDate",
                                    },
                                ]}
                            />
                        </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className="bg-white w-full overflow-hidden" style={{borderRadius: '12px', width: '100%'}}>
                        <DashboardBox2
                            icon={<div className="w-10 h-10 p-1.5 flex-shrink-0 rounded-full bg-[#ECFDF3] border-2 border-[#d5e6df]">
                                <IconInvoice className="w-full h-full object-contain" />
                            </div>}
                            title={"Total Payroll"}
                            loading={payrollMetricsLoading}
                            value={(CurrencyFormat(payrollMetrics?.data?.totalPayrollAmount) ?? "-")}
                            // subtext={`As at ${month}, ${year}`}
                        />
                        </div>
                    <div className="bg-white w-full overflow-hidden" style={{borderRadius: '12px'}}>
                        <DashboardBox2
                            icon={<div className="w-10 h-10 p-1.5 flex-shrink-0 rounded-full bg-[#FEF2F2] border-2 border-[#f9e4e3]">
                                <IconArrowDownLeft className="w-full h-full object-contain" />
                            </div>}
                            title={"Amount Withdrawn" }
                            loading={payrollMetricsLoading}
                            value={(CurrencyFormat(payrollMetrics?.data?.totalAmountWithdrawn) ?? "-")}
                            // subtext={`As at ${month}, ${year}`}
                        />
                    </div>
                    <div className="bg-white w-full overflow-hidden" style={{borderRadius: '12px'}}>
                        <DashboardBox2
                            icon={<div className="w-10 h-10 p-1.5 flex-shrink-0 rounded-full bg-[#F3F4F6] border-2 border-[#dddedf]">
                                <IconWalletDone className="w-full h-full object-contain" />
                            </div>}
                            title={"Balance to be paid"}
                            loading={payrollMetricsLoading}
                            value={(CurrencyFormat(payrollMetrics?.data?.totalPayrollbalance) ?? "-")}
                            // subtext={`As at ${month}, ${year}`}
                        />
                    </div>
                </div>
                <div className="mt-6 flex items-center">
                <InlineRouterTab
                    // queryMode={true}
                    tabMode={true}
                    items={[
                        {
                            title: "Reconcilliation",
                            value: "reconcilliation",
                        },
                        {
                            title: "Payment Notes",
                            value: "payment-notes",
                        }
                    ]}
                />
            </div>
            </div>
                    
            <div className="mt-6 box !px-0 !pb-0">
                {!isPaymentNotes ?
                <div className="">
                    <div className="px-4 font-medium text-xl">
                        Reconciliation
                    </div>
                    
                    <div className="px-4 mt-6 flex flex-wrap justify-between">
                        <div className="max-w-sm flex-grow sm:mr-6">
                            <SearchBox placeholder="Search employee" name="search" extraUrlParams="page=1" />
                        </div>
                        <div className="flex flex-wrap space-x-3 sm:space-x-6">
                            <div>
                                <Filter filters={[
                                    {
                                        title: "Month & Year",
                                        dataType: "month-year",
                                        option: {
                                            name: "month-year",
                                            placeholder: "Select",
                                        },
                                    },
                                ]}/>
                            </div>
                            <div>
                                <DownloadAsCSV
                                    ref={downloadAsCSVRef}
                                    tooltip="Download monthly reconciliation"
                                    filename="Monthly Reconciliation.csv"
                                    columns={[
                                        { label: "First Name", key: "firstName" },
                                        { label: "Last Name", key: "lastName" },
                                        { label: "Email Address", key: "email" },
                                        { label: "Bank Name", key: "bankName" },
                                        { label: "Bank Account Number", key: "bankAccountNumber" },
                                        { label: "Net Monthly Salary", key: "netMonthlySalary" },
                                        { label: "Amount Withdrawn", key: "totalAmountWithdrawn" },
                                        { label: "Last Withdrawn Date", key: "lastWithdrawn" },
                                        { label: "Salary Balance", key: "salaryBalance" },
                                    ]}
                                    click={() => {
                                        dispatch(payrollAction.downloadGetAllPayroll(transformFilters({...listParams, page: 1, limit: 10000}))).then(() => {
                                            downloadAsCSVRef.current?.downloadData();
                                        });
                                    }}
                                    loading={reportDownloadLoading}
                                    response={reportDownload?.docs}
                                />
                            </div>

                            {/* <div>
                                <Print component={printComponentRef} />
                            </div> */}
                        </div>
                    </div>

                    <div className="px-4">
                        <ActiveFilter filters={{"Month & Year": "month-year"}} />
                    </div>
                    
                    <div className="mt-6">
                        <div ref={printComponentRef}>
                            
                            <div className="mb-4 text-xl hidden print:block">
                                Reconciliation
                            </div>

                            <Table>
                                <Table.Head>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Employee Information</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Bank Account</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Net Monthly Salary</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Amount Withdrawn</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Last Withdrawal Date</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Salary Balance</th>
                                </Table.Head>
                                <Table.Body>

                                    <TableContent
                                        loading={reportLoading}
                                        loadingText="Loading monthly reconciliation"
                                        data={report?.payrolls}
                                        colspan={6}
                                    />

                                    {reportLoading === false && report?.payrolls?.docs?.map((reportData) =>
                                        <tr key={reportData._id}>
                                            <td>
                                                <div className="capitalize">
                                                    {reportData.firstName ?? "-"} {reportData.lastName}
                                                </div>
                                                <div className="text-fade">
                                                    {reportData.email ?? "-"}
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    {reportData.bankName ?? "-"}
                                                </div>
                                                <div className="text-fade">
                                                    {reportData.bankAccountNumber}
                                                </div>
                                            </td>
                                            <td>
                                                {CurrencyFormat(reportData.netMonthlySalary) ?? "-"}
                                            </td>
                                            <td>
                                                {CurrencyFormat(reportData.totalAmountWithdrawn) ?? "-"}
                                            </td>
                                            <td>
                                                {DateFormat(reportData.lastWithdrawn) ?? "-"}
                                            </td>
                                            <td>
                                                {CurrencyFormat(reportData.salaryBalance) ?? "-"}
                                            </td>
                                        </tr>
                                    )}

                                </Table.Body>
                            </Table>

                            <Maybe condition={reportLoading === false && report?.payrolls?.docs?.length > 0}>
                                <div className="mt-6">
                                    <Pagination data={report?.payrolls} />
                                </div>
                            </Maybe>

                        </div>
                    </div>
                </div>
                :
                <PaymentNotesList setInvoices={setInvoices} />
                }
            </div>

        </div>
    )
}

export const addOtherWithdrawalFilters = (params) => {
    let paramsPayload = {...params};

    if (params.search){
        if (isNaN(params.search)){
            paramsPayload = {
                ...paramsPayload,
                search: params.search,
            }
            delete paramsPayload["amount"];
        }
        else{
            paramsPayload = {
                ...paramsPayload,
                amount: params.search,
            }
            delete paramsPayload["search"];
        }
    }

    if (params.month && params.year){
        paramsPayload = {
            ...paramsPayload,
            month: MonthIndex(params.month),
            year: params.year,
        };
    }

    return paramsPayload;
}


export default List;